import * as actionTypes from '../../actionTypes';
import {moduleTypes} from '../../../util/constants';
import {getAccessToken} from '../../authenticateActions'
import {getAxiosInstance} from '../../../util/service';

export const getDriverInspectionReport=(empId, date, truckId, isDefected)=>{
    const _url=`truck-pre-inspection/search?date=${date}&truckNumber=${truckId}&driverId=${empId}&defectsOnly=${isDefected}&access_token=${getAccessToken()}`
    return async (dispatch) => {
       try{
           const response=await getAxiosInstance(moduleTypes.REPORT).get(_url); 
            if(response.status===200) {         
                dispatch({
                    type: actionTypes.GET_INSPECTION_REPORT,
                    inspectionReport:response.data
                });
            } else{
                    dispatch({
                        type: actionTypes.GET_INSPECTION_REPORT,
                        inspectionReport:undefined
                    });
                }            
        }
        catch(error){   
            dispatch({
                type: actionTypes.GET_INSPECTION_REPORT,
                inspectionReport:undefined
            });
        }
    }
}

export const getDriverInspectionReportPdf=(id)=>{
    const _url=`generate-pdf/${id}?access_token=${getAccessToken()}`;
    return async (dispatch) => {
        try{
                const resp=await getAxiosInstance(moduleTypes.REPORT).get(_url,  
                { headers: {'Accept': 'application/pdf'},
                responseType: 'blob'});
                   if (resp.status === 200) {
                    let blob = new Blob([resp.data], { type: 'application/pdf' } ),
                     url = window.URL.createObjectURL(blob)
                     window.open(url);
                     return resp.data;
                     } else {
                            return resp.data;
                        }
                     }catch(ex){
                    return undefined
                 }
             }
         }

         export const updateIsDefectsCorrected=(recordId,truckId,notes,driverIdtobeFix)=>{
             return async (dispatch) => {
                 try{
                     let _url=`/api/truck-pre-inspection/${recordId}/${truckId}?review=${notes}&requiredToFix=${driverIdtobeFix}&access_token=${getAccessToken()}`; 
                     const response= await getAxiosInstance(moduleTypes.REPORT).put(_url)
                     if(response.status===200) { 
                         return {statusCode:response.status, statusMsg:response.data.message};
                     } else{
                         return {statusCode:null, statusMsg:response.data.message}
                     }
                 }catch(error) {
                     return {statusCode:null, statusMsg:error.message}
                 }
             }
         }
